import { motion } from "framer-motion";
import { useEffect,useRef, useState } from "react";
import {IoPauseOutline, IoPlayOutline,IoPlaySkipBackOutline,IoPlaySkipForwardOutline } from "react-icons/io5";

import vinyl from "../../assets/svgs/round.svg";
import music from "../../assets/music/music.mp3";

export default function VinylPlayer() {
  const audioRef = useRef(null);

  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);

  // autoplay on load
  useEffect(() => {
  const startAudio = () => {
    audioRef.current?.play();
    setPlaying(true);
    window.removeEventListener("click", startAudio);
  };

  window.addEventListener("click", startAudio);

  return () => window.removeEventListener("click", startAudio);
}, []);

  // update progress
  const handleTimeUpdate = () => {
    const audio = audioRef.current;
    const percentage = (audio.currentTime / audio.duration) * 100;
    setProgress(percentage || 0);
  };

  // toggle play
  const toggleAudio = () => {
    const audio = audioRef.current;

    if (playing) {
      audio.pause();
    } else {
      audio.play();
    }

    setPlaying(!playing);
  };

  return (
    <div className="absolute bottom-14 right-5 rotate-12 md:right-36 md:bottom-28 flex flex-col items-center ">
      {/* audio */}
      <audio
        ref={audioRef}
        src={music}
        loop
        onTimeUpdate={handleTimeUpdate}
      />

      {/* vinyl */}
      <motion.div
        animate={playing ? { rotate: 360 } : { rotate: 0 }}
        transition={{
          ease: "linear",
          duration: 20,
          repeat: playing ? Infinity : 0,
        }}
        onClick={toggleAudio}
        className="cursor-pointer"
      >
        <img
          src={vinyl}
          alt="vinyl"
          className="w-32 md:w-44 select-none"
        />
      </motion.div>

      {/* minimal control */}
      <div className="flex -mt-2 mb-2  gap-4">

        <button className="text-[10px] md:text-xs">
            <IoPlaySkipBackOutline/>
        </button>

      <button
        onClick={toggleAudio}
        className=" text-black/70 hover:text-black transition"
        >
        {playing ? <IoPauseOutline/> : <IoPlayOutline/>}
      </button>
      <button className="text-[10px] md:text-xs">
            <IoPlaySkipForwardOutline/>
        </button>

    </div>

      {/* minimal progress bar */}
      <div
        className="w-24 md:w-32 h-[1.5px] bg-black/20 rounded overflow-hidden cursor-pointer"
        onClick={(e) => {
          const rect = e.currentTarget.getBoundingClientRect();
          const percent = (e.clientX - rect.left) / rect.width;
          const audio = audioRef.current;

          audio.currentTime = percent * audio.duration;
        }}
      >
        <div
          className="h-full bg-black"
          style={{ width: `${progress}%` }}
        />
      </div>


    </div>
  );
}